import React from 'react';
import PropTypes from 'prop-types';
export default function IconUpload({ className }) {
  return (
    <svg
      className={className}
      fill="none"
      height="25"
      viewBox="0 0 24 25"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 20.5996H18M12 16.5996V4.59961M12 4.59961L15.5 8.09961M12 4.59961L8.5 8.09961"
        stroke="#5E811E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.99"
      />
    </svg>
  );
}
IconUpload.propTypes = {
  className: PropTypes.string,
};
